module.exports = __webpack_public_path__ + "img/page_activasolo_slider02.b2feb31c.png";